import { gql } from '@apollo/client';

export const FETCH_ALL_CONDITIONS_QUERY = gql`
  query fetchAllConditions(
    $sourceUrl: String
    $count: String
    $offset: Int
    $dateFilter: Float
    $statusFilter: String
    $searchFilter: String
  ) {
    fetchAllConditions(
      sourceUrl: $sourceUrl
      count: $count
      offset: $offset
      dateFilter: $dateFilter
      statusFilter: $statusFilter
      searchFilter: $searchFilter
    ) {
      conditionList
      count
    }
  }
`;

export const FETCH_CONDITION_DETAILS_BY_ID = gql`
  query fetchConditionById($conditionId: String) {
    fetchConditionById(conditionId: $conditionId) {
      condition
      docArn
      documentReferenceId
    }
  }
`;
